<template>
 <List :key="$route.path"></List>
</template>
<script>
import List from './component/List'
export default {
  data () {
    return {}
  },
  components: {
    List
  },
  watch: {

  },
  created (){

  }
}
</script>
